import React, { useState } from "react";
import "./ProjectImageSlider.css";

export const imagesCtx = require.context(
  "../../assets/Projects",
  true,
  /\.(png|jpe?g|gif)$/i
);

export function getImages(folder) {
  if (!folder) return [];
  return imagesCtx
    .keys()
    .filter((k) => k.startsWith(`./${folder}/`))
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
    .map((k) => imagesCtx(k));
}

export default function ProjectImageSlider({ folder }) {
  const images = getImages(folder);
  const [idx, setIdx] = useState(0);

  if (images.length === 0) return null;

  const prev = (e) => {
    e.stopPropagation();
    setIdx((i) => (i - 1 + images.length) % images.length);
  };

  const next = (e) => {
    e.stopPropagation();
    setIdx((i) => (i + 1) % images.length);
  };

  return (
    <div className="proj-slider">
      <img
        src={images[idx]}
        alt={`screenshot ${idx + 1}`}
        className="proj-slider__img"
        draggable={false}
      />
      {images.length > 1 && (
        <>
          <button className="proj-slider__arrow proj-slider__arrow--left" onClick={prev}>
            &#8249;
          </button>
          <button className="proj-slider__arrow proj-slider__arrow--right" onClick={next}>
            &#8250;
          </button>
          <div className="proj-slider__dots">
            {images.map((_, i) => (
              <span
                key={i}
                className={`proj-slider__dot${i === idx ? " proj-slider__dot--active" : ""}`}
                onClick={(e) => { e.stopPropagation(); setIdx(i); }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
